var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import { flightDetailsActionTypes, loadControlTowerExperienceActionTypes, loadFlightControlActionTypes } from "../components/FlightDetails/FlightDetails.ducks.js";
import { loadOverviewActionTypes } from "./FlightOverview.ducks.js";
import { loadScorecardActionTypes } from "../components/FlightExperiments/FlightExperimentList.ducks.js";
import { loadFlightVariablesActionTypes } from "../components/FlightVariables/FlightVariables.ducks.js";
import { loadFlightTrafficActionTypes } from "../components/FlightTraffic/FlightTraffic.ducks.js";
import { loadPathsActionTypes, updateFlightActionTypes } from "../components/FlightEdit/FlightEdit.ducks.js";
import { queryFlightEpicReducer, loadCompositionEpicReducer, loadDependencyEpicReducer, compositionEditActionTypes, updateCompostionActionTypes } from "../components/Composition/Composition.ducks.js";
const defaultFlightDetailsReducerState = {
  flightDataById: {},
  flightQueries: {}
};
const defaultFlightReducerState = {
  flightOverview: getDefaultAsyncWrapperObj(),
  scorecardDataResult: getDefaultAsyncWrapperObj(),
  flightVariableResults: getDefaultAsyncWrapperObj(),
  updateResult: getDefaultAsyncWrapperObj(),
  flightControl: getDefaultAsyncWrapperObj(),
  controlTowerExperience: getDefaultAsyncWrapperObj(),
  managementGroupPaths: getDefaultAsyncWrapperObj(),
  flightTraffic: getDefaultAsyncWrapperObj(),
  composition: getDefaultAsyncWrapperObj(),
  dependencies: getDefaultAsyncWrapperObj(),
  compositionUpdate: { request: getDefaultAsyncWrapperObj() },
  compositionResultMessage: { message: null }
};
const flightReducerById = (state = defaultFlightDetailsReducerState, action) => {
  var _a;
  state = queryFlightEpicReducer.reduxChange(state, action);
  switch (action.type) {
    case flightDetailsActionTypes.SET_CURRENT_FLIGHT:
      return __spreadValues({}, state);
    default:
      if (!!((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.flightId)) {
        return __spreadProps(__spreadValues({}, state), {
          flightDataById: __spreadProps(__spreadValues({}, state.flightDataById), {
            [action.payload.flightId]: flightReducer(state.flightDataById[action.payload.flightId], action)
          })
        });
      }
      return __spreadValues({}, state);
  }
};
const flightReducer = (state = defaultFlightReducerState, action) => {
  state = loadCompositionEpicReducer.reduxChange(state, action);
  state = loadDependencyEpicReducer.reduxChange(state, action);
  switch (action.type) {
    case flightDetailsActionTypes.RESET_STATE:
      return __spreadValues(__spreadValues({}, state), defaultFlightReducerState);
    case loadOverviewActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        flightOverview: __spreadProps(__spreadValues({}, state.flightOverview), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadOverviewActionTypes.LOADED:
      const overviewResult = action;
      return __spreadProps(__spreadValues({}, state), {
        flightOverview: overviewResult.payload.result
      });
    case loadScorecardActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        scorecardDataResult: __spreadProps(__spreadValues({}, state.scorecardDataResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadScorecardActionTypes.LOADED:
      const scorecardResult = action;
      return __spreadProps(__spreadValues({}, state), {
        scorecardDataResult: scorecardResult.payload.result
      });
    case loadFlightVariablesActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        flightVariableResults: __spreadProps(__spreadValues({}, state.flightVariableResults), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadFlightVariablesActionTypes.LOADED:
      const variablesResult = action;
      return __spreadProps(__spreadValues({}, state), {
        flightVariableResults: variablesResult.payload.result
      });
    case updateFlightActionTypes.UPDATING: {
      return __spreadProps(__spreadValues({}, state), {
        updateResult: __spreadProps(__spreadValues({}, state.updateResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    }
    case updateFlightActionTypes.UPDATED: {
      const updatePayload = action;
      return __spreadProps(__spreadValues({}, state), {
        updateResult: updatePayload.payload.result
      });
    }
    case updateFlightActionTypes.CANCEL_UPDATE: {
      return __spreadProps(__spreadValues({}, state), {
        updateResult: { status: AsyncRequestStatus.NotStarted }
      });
    }
    case loadFlightControlActionTypes.LOADING: {
      return __spreadProps(__spreadValues({}, state), {
        flightControl: __spreadProps(__spreadValues({}, state.flightControl), {
          status: AsyncRequestStatus.Pending
        })
      });
    }
    case loadFlightControlActionTypes.LOADED: {
      const flightControlPayload = action;
      return __spreadProps(__spreadValues({}, state), {
        flightControl: flightControlPayload.payload.flightControl
      });
    }
    case loadPathsActionTypes.LOADING: {
      return __spreadProps(__spreadValues({}, state), {
        managementGroupPaths: __spreadProps(__spreadValues({}, state.managementGroupPaths), {
          status: AsyncRequestStatus.Pending
        })
      });
    }
    case loadPathsActionTypes.LOADED: {
      const pathsPayload = action;
      return __spreadProps(__spreadValues({}, state), {
        managementGroupPaths: pathsPayload.payload.paths
      });
    }
    case loadFlightTrafficActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        flightTraffic: __spreadProps(__spreadValues({}, state.flightTraffic), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadFlightTrafficActionTypes.LOADED:
      const loadFlightTrafficAction = action;
      return __spreadProps(__spreadValues({}, state), {
        flightTraffic: {
          data: loadFlightTrafficAction.payload.data,
          status: AsyncRequestStatus.Completed,
          error: loadFlightTrafficAction.payload.error
        }
      });
    case loadControlTowerExperienceActionTypes.LOADING: {
      return __spreadProps(__spreadValues({}, state), {
        controlTowerExperience: __spreadProps(__spreadValues({}, state.controlTowerExperience), {
          status: AsyncRequestStatus.Pending
        })
      });
    }
    case loadControlTowerExperienceActionTypes.LOADED: {
      const experiencePayload = action;
      return __spreadProps(__spreadValues({}, state), {
        controlTowerExperience: experiencePayload.payload.controlTowerExperience
      });
    }
    case updateCompostionActionTypes.UPDATING: {
      const compositionUpdate = action;
      return __spreadProps(__spreadValues({}, state), {
        compositionUpdate: __spreadProps(__spreadValues({}, state.compositionUpdate), {
          isVerifyOnly: compositionUpdate.payload.verifyOnly,
          request: __spreadProps(__spreadValues({}, state.compositionUpdate.request), { status: AsyncRequestStatus.Pending })
        })
      });
    }
    case updateCompostionActionTypes.UPDATED: {
      const compositionUpdate = action;
      const { result, verifyOnly, submissionMessage, isVerificationSuccess } = compositionUpdate.payload;
      return __spreadProps(__spreadValues({}, state), {
        dependencies: !!result.error ? state.dependencies : result,
        compositionUpdate: { isVerifyOnly: verifyOnly, request: result },
        compositionResultMessage: { message: submissionMessage, isVerificationSuccess }
      });
    }
    case compositionEditActionTypes.RESET_EDIT: {
      return __spreadProps(__spreadValues({}, state), {
        dependencies: { status: AsyncRequestStatus.NotStarted }
      });
    }
    case compositionEditActionTypes.DISMISS_MESSAGE: {
      return __spreadProps(__spreadValues({}, state), {
        compositionResultMessage: { message: null }
      });
    }
    default:
      return state;
  }
};
export {
  flightReducerById as default,
  defaultFlightDetailsReducerState,
  defaultFlightReducerState,
  flightReducer,
  flightReducerById
};
//# sourceMappingURL=FlightDetails.reducer.js.map
